import { createApp } from 'vue'
import App from './App.vue'
//import VueMeta from 'vue-meta'
import { createMetaManager } from 'vue-meta';

const app = createApp(App);
const metaManager = createMetaManager();
//app.use(VueMeta);
app.use(metaManager);
app.mount('#app');

